import { render } from "./Badge4.vue?vue&type=template&id=068122b6&scoped=true"
import script from "./Badge4.vue?vue&type=script&lang=js"
export * from "./Badge4.vue?vue&type=script&lang=js"

import "./Badge4.vue?vue&type=style&index=0&id=068122b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068122b6"]])

export default __exports__